import { extent } from 'd3-array'

const json_data = require('./data.json')

const data = json_data.map((d) => {
    d.label = `${d.names.join(',')} ${d.postcode}`
    d.postcode = d.postcode
    d.postcode_name = d.names.join(',')
    d.primary_mode = d.primary_pt_mode.toLowerCase()
    d.primary_mode_driving = d.primary_pt_and_drive_mode.toLowerCase()
    d.avg_pt_time = +d.pt_time
    d.avg_drive_time = +d.drive_time_traffic
    d.avg_rent = +d.weighted_avg_median_rent || 0
    if (d.avg_rent <= 0) d.avg_rent = -300
    d.region = d.sa4_name
    d.possible_names = d.names

    return d
})

const postcode_rankings = data.sort((a, b) => a.avg_pt_time - b.avg_pt_time)
    .map(d => d.postcode)

export default {
    data,
    avg_drive_time_domain: extent(data, d => d.avg_drive_time),
    avg_pt_time_domain: extent(data, d => d.avg_pt_time),
    avg_rent_domain: extent(data, d => d.avg_rent),
    postcode_rankings
}